import { UsaStates } from 'usa-states';
import {
  THEME_ATMORE,
  THEME_MONTGOMERY,
  THEME_WCC,
  THEME_WETUMPKA,
  THEME_BETHLEHEM,
  THEME_CHICAGO
} from 'themes';
import mapValues from 'lodash/mapValues';

const usStates = new UsaStates();

// This is the message used to notify the parent window
// that the page within the iframe has changed.
export const BOOKING_ENGINE_PAGE_CHANGED = 'BOOKING_ENGINE_PAGE_CHANGED';

// This message is used for setting the containing app's scrollY,
// for use in positioning modals for the embedded mobile app.
export const BOOKING_ENGINE_ON_SCROLL = 'BOOKING_ENGINE_ON_SCROLL';

// This is used to inform the parent window that bookg engine has
// received a 401
export const BOOKING_ENGINE_UNAUTHORIZED = 'BOOKING_ENGINE_UNAUTHORIZED';

export const FLOODLIGHT_ID = process.env.REACT_APP_GOOGLE_FLOODLIGHT_ID;

export const MAX_DISCOUNTED_OR_COMP_NIGHTS = 5;
export const MAX_WEB_OFFERS_IN_STAY = 2;
export const RACK_RATE = '10_FIT';
export const CLOSED = 'CLOSED';
export const SUNDAY = 0;
export const THURSDAY = 4;

export const US_STATES_OPTIONS = {};
usStates.states.forEach(state => {
  US_STATES_OPTIONS[state.abbreviation] = state.name;
});

export const BOOKING_ENGINE_BASE_PATH = '/';
export const GUEST_INFORMATION_PATH = '/guest-information';
export const REVIEW_SUBMIT_PATH = '/review';

export const ALL = 'ALL';
export const DELUXE_KING = 'DK';
export const STANDARD_KING = 'SK';
export const DELUXE_QUEEN = 'DLXQ';
export const DOUBLE_QUEEN = 'DQ';
export const STANDARD_QUEEN = 'SQ';
export const ULTRA_KING = 'UK';
export const GRAND_KING = 'GK';
export const CORNER_SUITE = 'CS';
export const PLATINUM_SUITE = 'PS';
export const VILLA = 'VILLA';
export const EXECUTIVE_SUITE = 'EK';
export const GRAND_EXECUTIVE_SUITE = 'GEK';
export const CHAIRMAN_SUITE = 'CS';
export const PRESIDENTIAL_SUITE = 'PK';
export const SUITE_KING = 'SUITEK';
export const ACCESSIBLE_KING = 'AK';
export const ACCESSIBLE_QUEEN = 'AQ';
export const ACCESSIBLE_EXECUTIVE_SUITE = 'AEXE';
export const FABULOUS_SUITE = 'FAB';
export const ACCESSIBLE_FABULOUS_SUITE = 'AFAB';
export const FANTASY_SUITE = 'FAN';
export const ACCESSIBLE_FANTASY_SUITE = 'AFAN';

export const ROOM_TYPES = {
  [ALL]: 'All',
  [DELUXE_KING]: 'Deluxe King',
  [STANDARD_KING]: 'Standard King',
  [DELUXE_QUEEN]: 'Deluxe Queen',
  [STANDARD_QUEEN]: 'Standard Queen',
  [ULTRA_KING]: 'Ultra King',
  [GRAND_KING]: 'Grand King',
  [SUITE_KING]: 'Suite King',
  [CORNER_SUITE]: 'Corner Suite',
  [PLATINUM_SUITE]: 'Platinum Suite',
  [EXECUTIVE_SUITE]: 'Executive Suite',
  [GRAND_EXECUTIVE_SUITE]: 'Grand Executive Suite',
  [PRESIDENTIAL_SUITE]: 'Presidential Suite',
  [VILLA]: 'Villa'
};

export const AAA = 'AAA';

export const DISCOUNT_TYPES = {
  [AAA]: 'AAA'
};

export const SMOKING = 'smoking';
export const NON_SMOKING = 'non-smoking';
export const NO_PREFERENCE = 'no-preference';

export const PROPERTY_ATMORE = 'atmore';
export const PROPERTY_BETHLEHEM = 'bethlehem';
export const PROPERTY_MONTGOMERY = 'montgomery';
export const PROPERTY_WETUMPKA = 'wetumpka';
export const PROPERTY_CHICAGO = 'chicago';

export const DEFAULT_PROPERTY = PROPERTY_ATMORE;

export const PROPERTIES = {
  [PROPERTY_ATMORE]: 'Atmore',
  [PROPERTY_BETHLEHEM]: 'Bethlehem',
  [PROPERTY_MONTGOMERY]: 'Montgomery',
  [PROPERTY_WETUMPKA]: 'Wetumpka',
  [PROPERTY_CHICAGO]: 'Chicago Southland'
};

export const THEME_PROPERTY_MAP = {
  [THEME_WCC]: DEFAULT_PROPERTY,
  [THEME_CHICAGO]: DEFAULT_PROPERTY,
  [THEME_ATMORE]: PROPERTY_ATMORE,
  [THEME_BETHLEHEM]: PROPERTY_BETHLEHEM,
  [THEME_MONTGOMERY]: PROPERTY_MONTGOMERY,
  [THEME_WETUMPKA]: PROPERTY_WETUMPKA
};

export const PROPERTY_CODES = {
  [PROPERTY_ATMORE]: 'WCA',
  [PROPERTY_BETHLEHEM]: 'WCB',
  [PROPERTY_MONTGOMERY]: 'WCM',
  [PROPERTY_WETUMPKA]: 'WCW',
  [PROPERTY_CHICAGO]: 'WCI'
};

/**
 * Call center phone numbers. Should be the 10 digit number (don't include country code).
 */
export const CALL_CENTER_PHONE_NUMBERS = {
  [PROPERTY_ATMORE]: 8669463360,
  [PROPERTY_CHICAGO]: 8669463361,
  [PROPERTY_BETHLEHEM]: 8777263777,
  [PROPERTY_MONTGOMERY]: 8669463360,
  [PROPERTY_WETUMPKA]: 8669463360
};

export const PROPERTY_TIMEZONES = {
  [PROPERTY_ATMORE]: 'America/Chicago',
  [PROPERTY_BETHLEHEM]: 'America/New_York',
  [PROPERTY_MONTGOMERY]: 'America/Chicago',
  [PROPERTY_WETUMPKA]: 'America/Chicago',
  [PROPERTY_CHICAGO]: 'America/Chicago'
};

export const PROPERTY_TAX = {
  [PROPERTY_ATMORE]: 0.08,
  [PROPERTY_CHICAGO]: 0.08, // TODO: Fix if different
  [PROPERTY_BETHLEHEM]: 0.1,
  [PROPERTY_MONTGOMERY]: 0.08,
  [PROPERTY_WETUMPKA]: 0.08
};

export const PROPERTY_CHECK_IN_OUT_TIMES = {
  [PROPERTY_ATMORE]: {
    checkIn: '16:00:00',
    checkOut: '10:00:00'
  },
  [PROPERTY_BETHLEHEM]: {
    checkIn: '16:00:00',
    checkOut: '10:00:00'
  },
  [PROPERTY_MONTGOMERY]: {
    checkIn: '16:00:00',
    checkOut: '10:00:00'
  },
  [PROPERTY_WETUMPKA]: {
    checkIn: '16:00:00',
    checkOut: '10:00:00'
  },
  [PROPERTY_CHICAGO]: {
    checkIn: '16:00:00',
    checkOut: '11:00:00'
  }
};

export const PAYMENT_METHODS = {
  MC: 'Mastercard',
  DS: 'Discover',
  VA: 'Visa',
  AX: 'American Express'
};

// Temporary room descriptions
export const ATMORE_QUEEN_DESC =
  'The 386 square feet Deluxe Room features two queen beds amidst a space defined by comfort and luxury. Plus, this layout offers the choice of spacious standing shower or normal tub & shower combo depending on preferences and availability.';
export const ATMORE_KING_DESC =
  'The 386 square feet Deluxe King features a king bed with the option of a spacious, walk-in shower or normal tub & shower combo. Every detail of the room was designed with your comfort and relaxation in mind.';
export const ATMORE_ULTRA_KING_DESC =
  'The 432 square feet Ultra King’s more-spacious main room and bathroom offer close to 50 square feet of additional space. It is a well-appointed, welcoming space designed with your luxury and comfort in mind.';
export const ATMORE_CORNER_SUITE_DESC =
  "Located at the two ends of each floor, these suites offer the best views on the property. Plus, each Corner Suite features a designated sitting area with an extra TV that’s perfect for entertaining at a moment's notice. With close to 280 additional square feet, these floor plans fit whatever your stay dictates.";
export const ATMORE_PLATINUM_SUITE_DESC =
  'Located on our Platinum Floors, 16-17, Platinum Suites offer double the square footage of the Deluxe Rooms with a separate living area that can be closed off from the bedroom. Plus, the spacious bathroom features a Jacuzzi tub – all 665 square feet were designed for your comfort and relaxation.';

export const MONTGOMERY_QUEEN_DESC =
  'The views are spectacular. But it’s what’s inside the room that’ll really take your breath away. Some places are almost too good to leave, like our Double Queen hotel rooms. Dressed in the best modern décor with a Beale Street Blues twist, it’s the perfect mixture of comfort and cool. With a Dream Weaver bed featuring an overstuffed down duvet, 100% Egyptian cotton sheets, a featherbed mattress topper and plenty of pillows, your sweet dreams are practically guaranteed. And when you aren’t sleeping, you can enjoy a wide range of amenities, from our rain-head showerheads to the 42” HD flat-screen TV and complimentary high-speed Internet. ';
export const MONTGOMERY_KING_DESC =
  'You’re gonna love your stay in one of our Deluxe King hotel rooms. Stylishly dressed in the best modern décor with a Blues twist, it’s the home-away-from-home that you always dreamed of. Each one features a Dream Weaver bed with an overstuffed down duvet, 100% Egyptian cotton sheets, a featherbed mattress topper and plenty of pillows. And that’s just what comes with the bed!';
export const MONTGOMERY_SUITE_DESC =
  'Things don’t get much better than an evening in one of our Suites. Featuring the best modern décor with a stylish Blues twist, stayin’ in one of these babies is like getting the best of both worlds. Guests can enjoy a Dream Weaver bed featuring an overstuffed down duvet, 100% Egyptian cotton sheets, a featherbed mattress topper and plenty of pillows. And as far as additional amenities go, between the 55” HD flat-screen TV and the complimentary high-speed Internet, there’s no shortage of ways to keep yourself entertained when you’re not out in the game.';

export const WETUMPKA_QUEEN_DESC =
  'When you’re done with the day, escape to the style and serenity of our Deluxe Queen luxury hotel rooms. Enjoy the view from the large panoramic windows and lounge chairs or rest like never before as you slip away to sleep on our Dream Weaver beds. All Deluxe Rooms offer walk-in showers and Accessible versions have tubs.';
export const WETUMPKA_KING_DESC =
  'Every detail of the 387 square foot Deluxe King rooms has been hand selected with your comfort in mind. From the luxurious lounge chairs by the large panoramic windows to the restful magic of the plush, Dream Weaver beds, every facet of these comforting king rooms has been designed for luxury and relaxation. All Deluxe Rooms also offer walk-in showers and Accessible versions come with tubs.';
export const WETUMPKA_CORNER_SUITE_DESC =
  'Spacious and bright, the Corner Suite offers unobstructed views of the Coosa River and the vibrant Alabama sunsets. These suites are well appointed with a separate sleeping and entertaining area. Each suite offers a private balcony and the baths have separate Jacuzzi tubs and oversized walk-in showers.';
export const WETUMPKA_PLATINUM_SUITE_DESC =
  'These impressive and sizable luxury suites have a fully private entertaining area with half-bath detached from the main bedroom. This is the perfect option for guests looking to spoil themselves or to entertain friends and family. Each suite offers a large wrap around balcony with stunning views of the Coosa River and downtown Wetumpka. ';

export const BETHLEHEM_KING_DESC =
  'Rest easy in our Deluxe King rooms—featuring a king-size pillow-top bed, media hubs, complimentary Wi-Fi and in-room remote checkout.' +
  '<br />' +
  'Wind Creek Bethlehem is a pet and animal-free property; however, ADA service animals are permitted. Thank you for your understanding and cooperation.';
export const BETHLEHEM_QUEEN_DESC =
  'Enjoy the relaxing atmosphere of our Deluxe Queen rooms, complete with two plush, queen pillow-top beds. Plus, media hubs, complimentary Wi-Fi and in-room remote checkout are standard in all rooms.' +
  '<br />' +
  'Wind Creek Bethlehem is a pet and animal-free property; however, ADA service animals are permitted. Thank you for your understanding and cooperation.';
export const BETHLEHEM_EXECUTIVE_SUITE_DESC =
  'Stretch out in style in our Executive Suite. A separate living area gives you space to relax, work or entertain during your stay. The spacious master bath offers both a soaking tub and glass-enclosed shower complete with a rainforest showerhead. Media hubs, free WiFi and in-room remote check out option are standard in all of our rooms.';
export const BETHLEHEM_CHAIRMAN_SUITE_DESC =
  'Revel in the luxury of our finest suite Enjoy all the first-class amenities the AAA 4 Diamond Award-winning Wind Creek Hotel has to offer.';
export const BETHLEHEM_PRESIDENTIAL_SUITE_DESC =
  'Take advantage of a full entertaining area complete with a dry bar and dining space for eight. A separate bedroom offers the ultimate comfort of a king-sized pillow top bed. The master bath is complete with a soaking tub and glass-enclosed, rainforest showerhead. Media hubs, free WiFi and in-room remote check out option are standard in all of our rooms.';

export const BETHLEHEM_TOWER_2_KING_DESC =
  'New to the Wind Creek Bethlehem experience—immerse yourself in timeless décor paired with rich jewel tones to foster the ultimate retreat that extends beyond our plush, king pillow-top bed. Located in close proximity to Spa at Wind Creek, this room also features media hubs, complimentary  Wi-Fi, and in-room remote checkout.' +
  '<br />' +
  'Wind Creek Bethlehem is a pet and animal-free property; however, ADA service animals are permitted. Thank you for your understanding and cooperation.';
export const BETHLEHEM_TOWER_2_QUEEN_DESC =
  'New to the Wind Creek Bethlehem experience—immerse yourself in timeless décor paired with rich jewel tones to foster the ultimate retreat that extends beyond our plush, queen pillow-top beds. Located in close proximity to Spa at Wind Creek, this room also features media hubs, complimentary  Wi-Fi, and in-room remote checkout.' +
  '<br />' +
  'Wind Creek Bethlehem is a pet and animal-free property; however, ADA service animals are permitted. Thank you for your understanding and cooperation.';
export const BETHLEHEM_TOWER_2_GRAND_KING_DESC =
  'New to the Wind Creek Bethlehem experience—immerse yourself in timeless décor paired with rich jewel tones to foster the ultimate retreat that extends beyond our plush, queen pillow-top beds. Located in close proximity to Spa at Wind Creek, this room also features floor-to-ceiling windows, a full seating area,  media hubs, complimentary  Wi-Fi, and in-room remote checkout.' +
  '<br />' +
  'Wind Creek Bethlehem is a pet and animal-free property; however, ADA service animals are permitted. Thank you for your understanding and cooperation.';
export const BETHLEHEM_TOWER_2_EXECUTIVE_SUITE_DESC =
  'Stretch out in style in our Executive Suite. A separate living area gives you space to relax, work or entertain during your stay. The spacious master bath offers both a soaking tub and a glass-enclosed shower complete with a rainforest showerhead. Media hub, free Wi-Fi and in-room remote checkout are standard in all of our rooms.';
export const BETHLEHEM_TOWER_2_GRAND_EXECUTIVE_SUITE_DESC =
  'New to the Wind Creek Bethlehem experience—immerse yourself in timeless décor paired with rich jewel tones to foster the ultimate retreat that extends beyond our plush, king pillow-top bed. Located in close proximity to Spa at Wind Creek, this room also features over xx sq. ft. of space,  floor-to-ceiling windows, a full seating area, media hubs, complimentary Wi-Fi, and in-room remote checkout.' +
  '<br />' +
  'Wind Creek Bethlehem is a pet and animal-free property; however, ADA service animals are permitted. Thank you for your understanding and cooperation.';
export const BETHLEHEM_TOWER_2_CHAIRMAN_SUITE_DESC =
  'Revel in the luxury of our finest suite. Enjoy all of the first-class amenities our AAA Four Diamond award-winning hotel has to offer.';
export const BETHLEHEM_TOWER_2_PRESIDENTIAL_SUITE_DESC =
  'Take advantage of a full entertaining area complete with a wet bar and dining space for eight. A separate bedroom offers the ultimate comfort of a King-size pillow-top bed. The master bath is complete with a soaking tub and a glass-enclosed shower with rainforest showerhead. Media hub, free Wi-Fi and in-room remote checkout are standard in all of our rooms.';

export const CHICAGO_DELUXE_KING_DESC = 'Average 350 Sq Ft - Sleep 2';
export const CHICAGO_ACCESSIBLE_KING_DESC = 'Average 350 Sq Ft - Sleep 2';
export const CHICAGO_QUEEN_DESC = '370 Sq Ft - Sleep 4';
export const CHICAGO_ACCESSIBLE_QUEEN_DESC = '370 Sq Ft - Sleep 4';
export const CHICAGO_EXECUTIVE_SUITE_DESC = '511 Sq Ft - Sleep 2';
export const CHICAGO_ACCESSIBLE_EXECUTIVE_SUITE_DESC = '511 Sq Ft - Sleep 2';
export const CHICAGO_FABULOUS_SUITE_DESC = 'Average 840 Sq Ft';
export const CHICAGO_ACCESSIBLE_FABULOUS_SUITE_DESC = 'Average 840 Sq Ft';
export const CHICAGO_FANTASY_SUITE_DESC = 'Average 1000 Sq Ft';
export const CHICAGO_ACCESSIBLE_FANTASY_SUITE_DESC = 'Average 1000 Sq Ft';

const FEATURES_DEFAULT = [
  'Air conditioning',
  'Daily housekeeping',
  'Desk',
  'TV',
  'Free WiFi',
  'Hair dryer',
  'Iron/ironing board',
  'Phone',
  'Room Service'
];

const BETHLEHEM_KING_FEATURES = [
  'Free wireless high-speed internet access',
  'Plush king-sized pillow-top bed',
  'Glass-enclosed shower',
  'Alarm clock',
  'In-suite safe',
  'In-room remote check-out option',
  '42" flat-screen LCD HDTV',
  'Media Hub',
  'Single cup coffee brewer',
  'ADA accessible rooms available'
];

const BETHLEHEM_QUEEN_FEATURES = [
  'Free wireless high-speed internet access',
  '2 Plush Queen sized pillow-top beds',
  'Glass-enclosed shower',
  'Alarm clock',
  'In-suite safe',
  'In-room remote check-out option',
  '42" flat-screen LCD HDTV',
  'Media Hub',
  'Single cup coffee brewer',
  'ADA accessible rooms available'
];

const BETHLEHEM_EXECUTIVE_SUITE_FEATURES = [
  'Free wireless high-speed internet access',
  'Two 42" flat-screen LCD HDTV\'s',
  'Glass-enclosed shower with rainforest head and soaking tub',
  'Full-sized queen sofa-sleeper',
  'Coffee table and oversized club chairs',
  'Refrigerator',
  'Media Hub',
  'Adjoining guest room with 2 queen beds (based upon availability)** Additional deluxe room rate will apply',
  'Single cup coffee brewer',
  'ADA accessible rooms available',
  'Plush king-sized pillow-top bed',
  '115 square foot bathroom featuring double-sink vanity',
  'Separate living/dining area',
  'Dining table that seats four',
  'Separate powder room',
  'Alarm clock',
  'In-suite safe'
];

const BETHLEHEM_PRESIDENTIAL_SUITE_FEATURES = [
  'Free wireless high-speed internet access',
  'Plush king-sized pillow-top bed',
  'Glass-enclosed shower with rainforest head and soaking tub',
  'Full-sized queen sofa-sleeper',
  'Dining table that seats eight',
  '2 Refrigerators',
  'Media Hub',
  'In-room remote check-out option',
  'Two 42" flat-screen LCD HDTV\'s',
  'Separate living/dining area',
  'Coffee table and oversized club chairs',
  'Wet bar with three stools',
  'Separate powder room',
  'ADA accessible rooms available'
];

const BETHLEHEM_FEATURES_TOWER_2 = {
  [DELUXE_KING]: [
    'Located in close proximity to Spa at Wind Creek',
    'Interior design paying homage to the Bethlehem Steel Corporation',
    'Free wireless high-speed internet access',
    'In-room remote checkout option',
    'Plush king-size pillow-top bed',
    '42" flat-screen LCD HDTV',
    'Glass-enclosed shower',
    'Media hub',
    'Alarm clock',
    'Single cup coffee brewer',
    'In-suite safe'
  ],
  [DELUXE_QUEEN]: [
    'Located in close proximity to Spa at Wind Creek',
    'Interior design paying homage to the Bethlehem Steel Corporation',
    'Free wireless high-speed internet access',
    'In-room remote checkout option',
    '2 Plush queen-size pillow-top beds',
    'Two plush Queen-size pillow-top beds',
    '42" flat-screen LCD HDTV',
    'Glass-enclosed shower',
    'Media hub',
    'Alarm clock',
    'Single cup coffee brewer',
    'In-suite safe'
  ],
  [GRAND_KING]: [
    'Floor-to-ceiling windows',
    'Seating area',
    'Located in close proximity to Spa at Wind Creek',
    'Interior design paying homage to the Bethlehem Steel Corporation',
    'Free wireless high-speed internet access',
    'In-room remote checkout option',
    'Plush king-size pillow-top bed',
    '42" flat-screen LCD HDTV',
    'Glass-enclosed shower',
    'Media hub',
    'Alarm clock',
    'Single cup coffee brewer',
    'In-suite safe'
  ],
  [EXECUTIVE_SUITE]: [
    'Free wireless high-speed internet access',
    'Plush King-size pillow-top bed',
    'Two 42" flat-screen LCD HDTVs',
    '115-square-foot bathroom featuring double-sink vanity',
    'Glass-enclosed shower with rainforest showerhead and soaking tub',
    'Separate living/dining area',
    'Queen-size sofa-sleeper',
    'Adjoining guest room with two Queen beds (based upon availability)* *Additional Deluxe Room rate will apply',
    'Coffee table and oversized club chairs',
    'Dining table that seats four',
    'Refrigerator',
    'Separate powder room',
    'Media hub',
    'Alarm clock',
    'Single cup coffee brewer',
    'In-suite safe'
  ],
  [GRAND_EXECUTIVE_SUITE]: [
    'Floor-to-ceiling windows',
    'Seating area',
    'Located in close proximity to Spa at Wind Creek',
    'Interior design paying homage to the Bethlehem Steel Corporation',
    'Free wireless high-speed internet access',
    'In-room remote checkout option',
    'Plush king-size pillow-top bed',
    '42" flat-screen LCD HDTV',
    'Glass-enclosed shower',
    'Media hub',
    'Alarm clock',
    'Single cup coffee brewer',
    'In-suite safe'
  ],
  [PRESIDENTIAL_SUITE]: [
    'Free wireless high-speed internet access',
    'In-room remote checkout option',
    'Plush King-size pillow-top bed',
    'Two 42" flat-screen LCD HDTVs',
    'Glass-enclosed shower with rainforest showerhead and soaking tub',
    'Separate living/dining area',
    'Queen-size sofa-sleeper',
    'Coffee table and oversized club chairs',
    'Dining table that seats eight',
    'Wet bar with three stools',
    'Two refrigerators',
    'Separate powder room',
    'Media hub'
  ],
  [CHAIRMAN_SUITE]: [
    'Formal living room with Full-size sleeper-sofa',
    'Wet bar',
    'Media hub',
    'Free wireless high-speed Internet access  ',
    'In-suite safe',
    'Double-door entrance with marble foyer',
    'Sitting areas in bedrooms',
    'Single-cup Keurig(R) coffee brewer with Starbucks(R) coffee',
    'In-room remote checkout option',
    'Master bedroom with plush pillow-top King-size bed',
    'Media room with Full-size sleeper-sofa',
    'Walk-in closet',
    'Dry vanity with mirror',
    'Formal dining area with seating for six',
    'Two luxurious bathrooms featuring marble floors',
    'Rainforest showerhead',
    'Double-sink vanity',
    'Separate powder room',
    'Tub with separate glass-enclosed showers',
    'TOTO elongated smart toilet with washlet',
    'Jo Malone London toiletries',
    '55" flat-screen LCD HDTV in media room',
    '55” flat-screen LCD HDTV in master bedroom',
    '55” flat-screen LCD HDTV in living room',
    '19” flat-screen LCD HDTV in bathroom mirror',
    'Sony(R) Bluetooth(R) alarm clock',
    'Valet parking service',
    'Complimentary self-parking'
  ]
};

const CHICAGO_ROOM_FEATURES = [
  'Free Wireless High speed internet',
  'Plush king / queen size pillow-top beds',
  'Glass enclosed shower',
  'Alarm Clock',
  'Single Cup Coffee Brewer',
  'In - Room Safe',
  'Clothing Steamer',
  'Hair dryer',
  '55" flat screen TV',
  'ADA accessible rooms available',
  'Complimentary in room water',
  'Large format Bath amenities from C.O. Bigelow and Grown Alchemist'
];

function applyDefaultRoomFeatures(rooms) {
  return mapValues(rooms, room =>
    Object.assign({}, { features: FEATURES_DEFAULT }, room)
  );
}

export const ROOMS = {
  [PROPERTY_CHICAGO]: applyDefaultRoomFeatures({
    DK: {
      roomType: DELUXE_KING,
      name: 'Deluxe King',
      smoking: false,
      accessible: false,
      description: CHICAGO_DELUXE_KING_DESC,
      features: CHICAGO_ROOM_FEATURES
    },
    AK: {
      roomType: ACCESSIBLE_KING,
      name: 'Accessible King',
      smoking: false,
      accessible: true,
      description: CHICAGO_ACCESSIBLE_KING_DESC,
      features: CHICAGO_ROOM_FEATURES
    },
    DQ: {
      roomType: DELUXE_QUEEN,
      name: 'Deluxe Queen/Queen',
      smoking: false,
      accessible: false,
      description: CHICAGO_QUEEN_DESC,
      features: CHICAGO_ROOM_FEATURES
    },
    AQ: {
      roomType: ACCESSIBLE_QUEEN,
      name: 'Accessible Queen/Queen',
      smoking: false,
      accessible: true,
      description: CHICAGO_ACCESSIBLE_QUEEN_DESC,
      features: CHICAGO_ROOM_FEATURES
    },
    EK: {
      roomType: EXECUTIVE_SUITE,
      name: 'Executive Suite',
      smoking: false,
      accessible: false,
      description: CHICAGO_EXECUTIVE_SUITE_DESC,
      features: CHICAGO_ROOM_FEATURES
    },
    AEXE: {
      roomType: ACCESSIBLE_EXECUTIVE_SUITE,
      name: 'Accessible Executive Suite',
      smoking: false,
      accessible: true,
      description: CHICAGO_ACCESSIBLE_EXECUTIVE_SUITE_DESC,
      features: CHICAGO_ROOM_FEATURES
    },
    FAB: {
      roomType: FABULOUS_SUITE,
      name: 'Fabulous Suite',
      smoking: false,
      accessible: false,
      description: CHICAGO_FABULOUS_SUITE_DESC,
      features: CHICAGO_ROOM_FEATURES
    },
    AFAB: {
      roomType: ACCESSIBLE_FABULOUS_SUITE,
      name: 'Accessible Fabulous Suite',
      smoking: false,
      accessible: true,
      description: CHICAGO_ACCESSIBLE_FABULOUS_SUITE_DESC,
      features: CHICAGO_ROOM_FEATURES
    },
    FAN: {
      roomType: FANTASY_SUITE,
      name: 'Fantasy Suite',
      smoking: false,
      accessible: false,
      description: CHICAGO_FANTASY_SUITE_DESC,
      features: CHICAGO_ROOM_FEATURES
    },
    AFAN: {
      roomType: ACCESSIBLE_FANTASY_SUITE,
      name: 'Accessible Fantasy Suite',
      smoking: false,
      accessible: true,
      description: CHICAGO_ACCESSIBLE_FANTASY_SUITE_DESC,
      features: CHICAGO_ROOM_FEATURES
    }
  }),
  [PROPERTY_ATMORE]: applyDefaultRoomFeatures({
    DKN: {
      roomType: DELUXE_KING,
      name: 'Deluxe King Non-Smoking',
      smoking: false,
      accessible: false,
      description: ATMORE_KING_DESC
    },
    DKNV: {
      roomType: DELUXE_KING,
      name: 'Deluxe King Non-Smoking View',
      smoking: false,
      accessible: false,
      description: ATMORE_KING_DESC
    },
    DQNV: {
      roomType: DELUXE_QUEEN,
      name: 'Deluxe Q/Q Non-Smoking View',
      smoking: false,
      accessible: false,
      description: ATMORE_QUEEN_DESC
    },
    CQSV: {
      roomType: DELUXE_QUEEN,
      name: 'Deluxe Q/Q Smoking View',
      smoking: true,
      accessible: false,
      description: ATMORE_QUEEN_DESC
    },
    DQN: {
      roomType: DELUXE_QUEEN,
      name: 'Deluxe Q/Q Non-Smoking',
      smoking: false,
      accessible: false,
      description: ATMORE_QUEEN_DESC
    },
    PKSV: {
      roomType: PLATINUM_SUITE,
      name: 'Platinum Suite King Smoking View',
      smoking: true,
      accessible: false,
      description: ATMORE_PLATINUM_SUITE_DESC
    },
    DKSV: {
      roomType: DELUXE_KING,
      name: 'Deluxe King Smoking View',
      smoking: true,
      accessible: false,
      description: ATMORE_KING_DESC
    },
    CQS: {
      roomType: DELUXE_QUEEN,
      name: 'Deluxe Q/Q Smoking',
      smoking: true,
      accessible: false,
      description: ATMORE_QUEEN_DESC
    },
    DKS: {
      roomType: DELUXE_KING,
      name: 'Deluxe King Smoking',
      smoking: true,
      accessible: false,
      description: ATMORE_KING_DESC
    },
    PKN: {
      roomType: PLATINUM_SUITE,
      name: 'Platinum Suite King Non-Smoking',
      smoking: false,
      accessible: false,
      description: ATMORE_PLATINUM_SUITE_DESC
    },
    DQS: {
      roomType: DELUXE_QUEEN,
      name: 'Deluxe Q/Q Smoking',
      smoking: true,
      accessible: false,
      description: ATMORE_QUEEN_DESC
    },
    CQN: {
      roomType: DELUXE_QUEEN,
      name: 'Deluxe Q/Q Non-Smoking',
      smoking: false,
      accessible: false,
      description: ATMORE_QUEEN_DESC
    },
    PKNV: {
      roomType: PLATINUM_SUITE,
      name: 'Platinum Suite King Non-Smoking View',
      smoking: false,
      accessible: false,
      description: ATMORE_PLATINUM_SUITE_DESC
    },
    DQSV: {
      roomType: DELUXE_QUEEN,
      name: 'Deluxe Q/Q Smoking View',
      smoking: true,
      accessible: false,
      description: ATMORE_QUEEN_DESC
    },
    CQNV: {
      roomType: DELUXE_QUEEN,
      name: 'Deluxe Q/Q Non-Smoking View',
      smoking: false,
      accessible: false,
      description: ATMORE_QUEEN_DESC
    },
    UKNV: {
      roomType: ULTRA_KING,
      name: 'Ultra King Non-Smoking  View',
      smoking: false,
      accessible: false,
      description: ATMORE_ULTRA_KING_DESC
    },
    UKS: {
      roomType: ULTRA_KING,
      name: 'Ultra King Smoking',
      smoking: true,
      accessible: false,
      description: ATMORE_ULTRA_KING_DESC
    },
    UKSV: {
      roomType: ULTRA_KING,
      name: 'Ultra King Smoking View',
      smoking: true,
      accessible: false,
      description: ATMORE_ULTRA_KING_DESC
    },
    UKN: {
      roomType: ULTRA_KING,
      name: 'Ultra King Non-Smoking',
      smoking: false,
      accessible: false,
      description: ATMORE_ULTRA_KING_DESC
    },
    SKNV: {
      roomType: CORNER_SUITE,
      name: 'Corner Suite King Non-Smoking View',
      smoking: false,
      accessible: false,
      description: ATMORE_CORNER_SUITE_DESC
    },
    SKN: {
      roomType: CORNER_SUITE,
      name: 'Corner Suite King Non-Smoking',
      smoking: false,
      accessible: false,
      description: ATMORE_CORNER_SUITE_DESC
    },
    VILLA: {
      roomType: VILLA,
      name: 'Villa Suite',
      smoking: true,
      accessible: false
    },
    AKNV: {
      roomType: STANDARD_KING,
      name: 'Accessible King Non-Smoking View',
      smoking: false,
      accessible: true,
      description: ATMORE_KING_DESC
    },
    AKSV: {
      roomType: STANDARD_KING,
      name: 'Accessible King Smoking View',
      smoking: true,
      accessible: true,
      description: ATMORE_KING_DESC
    },
    AQS: {
      roomType: STANDARD_QUEEN,
      name: 'Accessible Queen Smoking',
      smoking: true,
      accessible: true,
      description: ATMORE_QUEEN_DESC
    },
    AQN: {
      roomType: STANDARD_QUEEN,
      name: 'Accessible Q/Q Non-Smoking',
      smoking: false,
      accessible: true,
      description: ATMORE_QUEEN_DESC
    },
    PKS: {
      roomType: PLATINUM_SUITE,
      name: 'Platinum Suite King Smoking',
      smoking: true,
      accessible: false,
      description: ATMORE_PLATINUM_SUITE_DESC
    },
    SKS: {
      roomType: CORNER_SUITE,
      name: 'Corner Suite King Smoking',
      smoking: true,
      accessible: false,
      description: ATMORE_CORNER_SUITE_DESC
    },
    SKSV: {
      roomType: CORNER_SUITE,
      name: 'Corner Suite King Smoking View',
      smoking: true,
      accessible: false,
      description: ATMORE_CORNER_SUITE_DESC
    },
    EDK: {
      roomType: STANDARD_KING,
      name: 'Escape King Non-Smoking',
      smoking: false,
      accessible: false,
      description: ATMORE_KING_DESC
    },
    EDKV: {
      roomType: STANDARD_KING,
      name: 'Escape King Non-Smoking View',
      smoking: false,
      accessible: false,
      description: ATMORE_KING_DESC
    },
    EDQ: {
      roomType: STANDARD_QUEEN,
      name: 'Escape Q/Q Non-Smoking',
      smoking: false,
      accessible: false,
      description: ATMORE_QUEEN_DESC
    },
    EDQV: {
      roomType: STANDARD_QUEEN,
      name: 'Escape Q/Q Non-Smoking View',
      smoking: false,
      accessible: false,
      description: ATMORE_QUEEN_DESC
    },
    EUK: {
      roomType: ULTRA_KING,
      name: 'Escape Ultra King Non-Smoking',
      smoking: false,
      accessible: false,
      description: ATMORE_ULTRA_KING_DESC
    },
    EUKV: {
      roomType: ULTRA_KING,
      name: 'Escape Ultra King Non-Smoking View',
      smoking: false,
      accessible: false,
      description: ATMORE_ULTRA_KING_DESC
    },
    ESK: {
      roomType: CORNER_SUITE,
      name: 'Escape Corner Suite King N/S View',
      smoking: false,
      accessible: false,
      description: ATMORE_CORNER_SUITE_DESC
    },
    ESKV: {
      roomType: CORNER_SUITE,
      name: 'Escape Corner Suite King N/S View',
      smoking: false,
      accessible: false,
      description: ATMORE_CORNER_SUITE_DESC
    },
    AKN: {
      roomType: STANDARD_KING,
      name: 'Accessible King Non-Smoking',
      smoking: false,
      accessible: true,
      description: ATMORE_KING_DESC
    },
    AKS: {
      roomType: STANDARD_KING,
      name: 'Accessible King Smoking',
      smoking: true,
      accessible: true,
      description: ATMORE_KING_DESC
    }
  }),
  [PROPERTY_WETUMPKA]: applyDefaultRoomFeatures({
    RKN: {
      roomType: STANDARD_KING,
      name: 'Standard King Non-Smoking',
      smoking: false,
      accessible: false,
      description: WETUMPKA_KING_DESC
    },
    AQS: {
      roomType: STANDARD_QUEEN,
      name: 'Accessible Queen Smoking',
      smoking: true,
      accessible: true,
      description: WETUMPKA_QUEEN_DESC
    },
    SKN: {
      roomType: CORNER_SUITE,
      name: 'Corner Suite Non-Smoking',
      smoking: false,
      accessible: false,
      description: WETUMPKA_CORNER_SUITE_DESC
    },
    SKS: {
      roomType: CORNER_SUITE,
      name: 'Corner Suite Smoking',
      smoking: true,
      accessible: false,
      description: WETUMPKA_CORNER_SUITE_DESC
    },
    AQN: {
      roomType: STANDARD_QUEEN,
      name: 'Accessible Queen Non-Smoking',
      smoking: false,
      accessible: true,
      description: WETUMPKA_QUEEN_DESC
    },
    SKNA: {
      roomType: CORNER_SUITE,
      name: 'Accessible Corner Suite Non Smoking',
      smoking: false,
      accessible: true,
      description: WETUMPKA_CORNER_SUITE_DESC
    },
    DQS: {
      roomType: DELUXE_QUEEN,
      name: 'Deluxe Queen Smoking',
      smoking: true,
      accessible: false,
      description: WETUMPKA_QUEEN_DESC
    },
    PKN: {
      roomType: PLATINUM_SUITE,
      name: 'Platinum Suite Non-Smoking',
      smoking: false,
      accessible: false,
      description: WETUMPKA_PLATINUM_SUITE_DESC
    },
    DQN: {
      roomType: DELUXE_QUEEN,
      name: 'Deluxe Queen Non-Smoking',
      smoking: false,
      accessible: false,
      description: WETUMPKA_QUEEN_DESC
    },
    AKN: {
      roomType: STANDARD_KING,
      name: 'Accessible King Non-smoking',
      smoking: false,
      accessible: true,
      description: WETUMPKA_KING_DESC
    },
    PKS: {
      roomType: PLATINUM_SUITE,
      name: 'Platinum Suite Smoking',
      smoking: true,
      accessible: false,
      description: WETUMPKA_PLATINUM_SUITE_DESC
    },
    AKS: {
      roomType: STANDARD_KING,
      name: 'Accessible King Smoking',
      smoking: true,
      accessible: true,
      description: WETUMPKA_KING_DESC
    },
    DKS: {
      roomType: DELUXE_KING,
      name: 'Deluxe King Smoking',
      smoking: true,
      accessible: false,
      description: WETUMPKA_KING_DESC
    },
    DKN: {
      roomType: DELUXE_KING,
      name: 'Deluxe King Non-Smoking',
      smoking: false,
      accessible: false,
      description: WETUMPKA_KING_DESC
    },
    PKNA: {
      roomType: PLATINUM_SUITE,
      name: 'Accessible Platinum Suite Non Smoking',
      smoking: false,
      accessible: true,
      description: WETUMPKA_PLATINUM_SUITE_DESC
    }
  }),
  [PROPERTY_MONTGOMERY]: applyDefaultRoomFeatures({
    DKN: {
      roomType: DELUXE_KING,
      name: 'Deluxe King Non-Smoking',
      smoking: false,
      accessible: false,
      description: MONTGOMERY_KING_DESC
    },
    DKNA: {
      roomType: DELUXE_KING,
      name: 'Deluxe King Accessible Non-Smoking',
      smoking: false,
      accessible: true,
      description: MONTGOMERY_KING_DESC
    },
    DQN: {
      roomType: DELUXE_QUEEN,
      name: 'Deluxe Queen Non-Smoking',
      smoking: false,
      accessible: false,
      description: MONTGOMERY_QUEEN_DESC
    },
    DQNA: {
      roomType: DELUXE_QUEEN,
      name: 'Deluxe Queens Non-Smoking Accessible',
      smoking: false,
      accessible: true,
      description: MONTGOMERY_QUEEN_DESC
    },
    DQNV: {
      roomType: DELUXE_QUEEN,
      name: 'Deluxe Queen View Non-Smoking',
      smoking: false,
      accessible: false,
      description: MONTGOMERY_QUEEN_DESC
    },
    SKN: {
      roomType: SUITE_KING,
      name: 'Suite King Non-Smoking',
      smoking: false,
      accessible: false,
      description: MONTGOMERY_SUITE_DESC
    },
    SKNA: {
      roomType: SUITE_KING,
      name: 'Suite King Non-Smoking Accessible',
      smoking: false,
      accessible: true,
      description: MONTGOMERY_SUITE_DESC
    }
  }),
  [PROPERTY_BETHLEHEM]: applyDefaultRoomFeatures({
    CK: {
      roomType: DELUXE_KING,
      name: 'South Tower Chairman Deluxe King',
      smoking: false,
      accessible: false,
      description: BETHLEHEM_KING_DESC,
      features: BETHLEHEM_KING_FEATURES
    },
    DK: {
      roomType: DELUXE_KING,
      name: 'South Tower Deluxe King',
      smoking: false,
      accessible: false,
      description: BETHLEHEM_KING_DESC,
      features: BETHLEHEM_KING_FEATURES
    },
    SK: {
      roomType: DELUXE_KING,
      name: 'South Tower Smoking Deluxe King',
      smoking: true,
      accessible: false,
      description: BETHLEHEM_KING_DESC,
      features: BETHLEHEM_KING_FEATURES
    },
    AK: {
      roomType: DELUXE_KING,
      name: 'South Tower Handicap Accessible Deluxe King',
      smoking: false,
      accessible: true,
      description: BETHLEHEM_KING_DESC,
      features: BETHLEHEM_KING_FEATURES
    },
    S1: {
      roomType: DELUXE_KING,
      name: 'South Tower Handicap Accessible Smoking Deluxe King',
      smoking: true,
      accessible: true,
      description: BETHLEHEM_KING_DESC,
      features: BETHLEHEM_KING_FEATURES
    },
    DQ: {
      roomType: DELUXE_QUEEN,
      name: 'South Tower Deluxe Queen',
      smoking: false,
      accessible: false,
      description: BETHLEHEM_QUEEN_DESC,
      features: BETHLEHEM_QUEEN_FEATURES
    },
    SQ: {
      roomType: DELUXE_QUEEN,
      name: 'South Tower Smoking Deluxe Queen',
      smoking: true,
      accessible: false,
      description: BETHLEHEM_QUEEN_DESC,
      features: BETHLEHEM_QUEEN_FEATURES
    },
    AQ: {
      roomType: DELUXE_QUEEN,
      name: 'South Tower Handicap Accessible Deluxe Queen',
      smoking: false,
      accessible: true,
      description: BETHLEHEM_QUEEN_DESC,
      features: BETHLEHEM_QUEEN_FEATURES
    },
    S2: {
      roomType: DELUXE_QUEEN,
      name: 'South Tower Handicap Accessible Smoking Deluxe Queen',
      smoking: true,
      accessible: true,
      description: BETHLEHEM_QUEEN_DESC,
      features: BETHLEHEM_QUEEN_FEATURES
    },
    CE: {
      roomType: EXECUTIVE_SUITE,
      name: 'South Tower Chairman Executive',
      smoking: false,
      accessible: false,
      description: BETHLEHEM_EXECUTIVE_SUITE_DESC,
      features: BETHLEHEM_EXECUTIVE_SUITE_FEATURES
    },
    AS: {
      roomType: EXECUTIVE_SUITE,
      name: 'South Tower Chairman Executive Suite Accessible',
      smoking: false,
      accessible: true,
      description: BETHLEHEM_EXECUTIVE_SUITE_DESC,
      features: BETHLEHEM_EXECUTIVE_SUITE_FEATURES
    },
    EK: {
      roomType: EXECUTIVE_SUITE,
      name: 'South Tower Executive Suite',
      smoking: false,
      accessible: false,
      description: BETHLEHEM_EXECUTIVE_SUITE_DESC,
      features: BETHLEHEM_EXECUTIVE_SUITE_FEATURES
    },
    AE: {
      roomType: EXECUTIVE_SUITE,
      name: 'South Tower Handicap Accessible Executive Suite',
      smoking: false,
      accessible: true,
      description: BETHLEHEM_EXECUTIVE_SUITE_DESC,
      features: BETHLEHEM_EXECUTIVE_SUITE_FEATURES
    },
    SE: {
      roomType: EXECUTIVE_SUITE,
      name: 'South Tower Smoking Executive Suite',
      smoking: true,
      accessible: false,
      description: BETHLEHEM_EXECUTIVE_SUITE_DESC,
      features: BETHLEHEM_EXECUTIVE_SUITE_FEATURES
    },
    CP: {
      roomType: PRESIDENTIAL_SUITE,
      name: 'South Tower Chairman Presidential',
      smoking: false,
      accessible: false,
      description: BETHLEHEM_PRESIDENTIAL_SUITE_DESC,
      features: BETHLEHEM_PRESIDENTIAL_SUITE_FEATURES
    },
    CS: {
      roomType: CHAIRMAN_SUITE,
      name: 'South Tower Chairman Suite',
      smoking: false,
      accessible: false,
      description: BETHLEHEM_CHAIRMAN_SUITE_DESC,
      features: BETHLEHEM_PRESIDENTIAL_SUITE_FEATURES
    },
    PK: {
      roomType: PRESIDENTIAL_SUITE,
      name: 'South Tower Presidential Suite',
      smoking: false,
      accessible: false,
      description: BETHLEHEM_PRESIDENTIAL_SUITE_DESC,
      features: BETHLEHEM_PRESIDENTIAL_SUITE_FEATURES
    },
    AP: {
      roomType: PRESIDENTIAL_SUITE,
      name: 'South Tower Handicap Accessible Presidential Suite',
      smoking: false,
      accessible: true,
      description: BETHLEHEM_PRESIDENTIAL_SUITE_DESC,
      features: BETHLEHEM_PRESIDENTIAL_SUITE_FEATURES
    },
    SP: {
      roomType: PRESIDENTIAL_SUITE,
      name: 'South Tower Smoking Presidential Suite',
      smoking: true,
      accessible: false,
      description: BETHLEHEM_PRESIDENTIAL_SUITE_DESC,
      features: BETHLEHEM_PRESIDENTIAL_SUITE_FEATURES
    },
    // Tower 2 Room Types below
    EK2: {
      roomType: EXECUTIVE_SUITE,
      name: 'North Tower Executive King Suite Non-Smoking',
      smoking: false,
      accessible: false,
      description: BETHLEHEM_TOWER_2_EXECUTIVE_SUITE_DESC,
      features: BETHLEHEM_FEATURES_TOWER_2[EXECUTIVE_SUITE]
    },
    SE2: {
      roomType: EXECUTIVE_SUITE,
      name: 'North Tower Executive Suite Smoking',
      smoking: true,
      accessible: false,
      description: BETHLEHEM_TOWER_2_EXECUTIVE_SUITE_DESC,
      features: BETHLEHEM_FEATURES_TOWER_2[EXECUTIVE_SUITE]
    },
    AP2: {
      roomType: PRESIDENTIAL_SUITE,
      name: 'North Tower Accessible Presidential Suite',
      smoking: false,
      accessible: true,
      description: BETHLEHEM_TOWER_2_PRESIDENTIAL_SUITE_DESC,
      features: BETHLEHEM_FEATURES_TOWER_2[PRESIDENTIAL_SUITE]
    },
    PK2: {
      roomType: PRESIDENTIAL_SUITE,
      name: 'North Tower Presidential Suite Non-Smoking',
      smoking: false,
      accessible: false,
      description: BETHLEHEM_TOWER_2_PRESIDENTIAL_SUITE_DESC,
      features: BETHLEHEM_FEATURES_TOWER_2[PRESIDENTIAL_SUITE]
    },
    GK2: {
      roomType: GRAND_KING,
      name: 'North Tower Grand King Non-Smoking',
      smoking: false,
      accessible: false,
      description: BETHLEHEM_TOWER_2_GRAND_KING_DESC,
      features: BETHLEHEM_FEATURES_TOWER_2[GRAND_KING]
    },
    AK2: {
      roomType: DELUXE_KING,
      name: 'North Tower Accessible King Non-Smoking',
      smoking: false,
      accessible: true,
      description: BETHLEHEM_TOWER_2_KING_DESC,
      features: BETHLEHEM_FEATURES_TOWER_2[DELUXE_KING]
    },
    AQ2: {
      roomType: DELUXE_QUEEN,
      name: 'North Tower Accessible Queens Non-Smoking',
      smoking: false,
      accessible: true,
      description: BETHLEHEM_TOWER_2_QUEEN_DESC,
      features: BETHLEHEM_FEATURES_TOWER_2[DELUXE_QUEEN]
    },
    AS2: {
      roomType: DELUXE_QUEEN,
      name: 'North Tower Accessible Queens Smoking',
      smoking: true,
      accessible: true,
      description: BETHLEHEM_TOWER_2_QUEEN_DESC,
      features: BETHLEHEM_FEATURES_TOWER_2[DELUXE_QUEEN]
    },
    DQ2: {
      roomType: DELUXE_QUEEN,
      name: 'North Tower Deluxe Queens Non-Smoking',
      smoking: false,
      accessible: false,
      description: BETHLEHEM_TOWER_2_QUEEN_DESC,
      features: BETHLEHEM_FEATURES_TOWER_2[DELUXE_QUEEN]
    },
    DK2: {
      roomType: DELUXE_KING,
      name: 'North Tower Deluxe King Non-Smoking',
      smoking: false,
      accessible: false,
      description: BETHLEHEM_TOWER_2_KING_DESC,
      features: BETHLEHEM_FEATURES_TOWER_2[DELUXE_KING]
    },
    SQ2: {
      roomType: DELUXE_QUEEN,
      name: 'North Tower Deluxe Queens Smoking',
      smoking: true,
      accessible: false,
      description: BETHLEHEM_TOWER_2_QUEEN_DESC,
      features: BETHLEHEM_FEATURES_TOWER_2[DELUXE_QUEEN]
    },
    SK2: {
      roomType: DELUXE_KING,
      name: 'North Tower Deluxe King Smoking',
      smoking: true,
      accessible: false,
      description: BETHLEHEM_TOWER_2_KING_DESC,
      features: BETHLEHEM_FEATURES_TOWER_2[DELUXE_KING]
    },
    GS2: {
      roomType: EXECUTIVE_SUITE,
      name: 'North Tower One King Br, One QQ Bedroom Non-Smoking',
      smoking: false,
      accessible: false,
      description: BETHLEHEM_TOWER_2_EXECUTIVE_SUITE_DESC,
      features: BETHLEHEM_FEATURES_TOWER_2[EXECUTIVE_SUITE]
    },
    SGK2: {
      roomType: GRAND_KING,
      name: 'North Tower Smoking Grand King',
      smoking: true,
      accessible: false,
      description: BETHLEHEM_TOWER_2_GRAND_KING_DESC,
      features: BETHLEHEM_FEATURES_TOWER_2[GRAND_KING]
    },
    SGE2: {
      roomType: GRAND_EXECUTIVE_SUITE,
      name: 'North Tower Smoking Grand Executive',
      smoking: true,
      accessible: false,
      description: BETHLEHEM_TOWER_2_GRAND_EXECUTIVE_SUITE_DESC,
      features: BETHLEHEM_FEATURES_TOWER_2[GRAND_EXECUTIVE_SUITE]
    },
    GE2: {
      roomType: GRAND_EXECUTIVE_SUITE,
      name: 'North Tower Grand Executive Non-Smoking',
      smoking: false,
      accessible: false,
      description: BETHLEHEM_TOWER_2_GRAND_EXECUTIVE_SUITE_DESC,
      features: BETHLEHEM_FEATURES_TOWER_2[GRAND_EXECUTIVE_SUITE]
    }
  })
};

// This is a mapping of our internal room type const to Opera room type codes.
export const ROOM_TYPE_CODES_FOR_SIZE = {
  [DELUXE_KING]: [
    'DKN',
    'DKNV',
    'DKS',
    'DKSV',
    'DKNA',
    'CK',
    'DK',
    'SK',
    'AK',
    'S1',
    // WCB Tower 2
    'AK2',
    'DK2',
    'SK2'
  ],
  [STANDARD_KING]: ['AKNV', 'AKSV', 'AKN', 'AKS', 'EDK', 'EDKV', 'RKN'],
  [DELUXE_QUEEN]: [
    'DQN',
    'DQNV',
    'CQSV',
    'CQS',
    'DQS',
    'CQN',
    'DQSV',
    'CQNV',
    'DQ',
    'SQ',
    'AQ',
    'S2',
    // WCB Tower 2
    'AQ2',
    'AS2',
    'DQ2',
    'SQ2'
  ],
  [STANDARD_QUEEN]: ['AQN', 'AQS', 'EDQ', 'EDQV'],
  [ULTRA_KING]: ['UKN', 'UKNV', 'UKS', 'UKSV', 'EUK', 'EUKV'],
  [SUITE_KING]: ['SKN', 'SKNA'],
  [GRAND_KING]: ['GK2', 'SGK2'],
  [CORNER_SUITE]: ['SKNV', 'SKN', 'SKS', 'SKSV', 'ESK', 'ESKV', 'SKNA'],
  [PLATINUM_SUITE]: ['PKSV', 'PKN', 'PKNV', 'PKS', 'PKNA'],
  [EXECUTIVE_SUITE]: [
    'EK',
    'SKNV',
    'AE',
    'SE',
    'SKNA',
    'SKS',
    'CE',
    'AS',
    'EK2',
    'SE2'
  ],
  [GRAND_EXECUTIVE_SUITE]: ['GE2', 'SGE2'],
  [PRESIDENTIAL_SUITE]: [
    'PKNA',
    'PKS',
    'PKN',
    'PK',
    'SP',
    'AP',
    'CP',
    'AP2',
    'PK2'
  ],
  [CHAIRMAN_SUITE]: ['CS', 'DKNV'],
  [VILLA]: ['VILLA'],
  [ACCESSIBLE_KING]: ['AK'],
  [ACCESSIBLE_QUEEN]: ['AQ'],
  [ACCESSIBLE_EXECUTIVE_SUITE]: ['AEXE'],
  [FABULOUS_SUITE]: ['FAB'],
  [ACCESSIBLE_KING]: 'AK',
  [ACCESSIBLE_QUEEN]: 'AQ',
  [ACCESSIBLE_EXECUTIVE_SUITE]: 'AEXE',
  [FABULOUS_SUITE]: 'FAB',
  [ACCESSIBLE_FABULOUS_SUITE]: 'AFAB',
  [FANTASY_SUITE]: 'FAN',
  [ACCESSIBLE_FANTASY_SUITE]: 'AFAN',
  [ALL]: []
};

// WCB has 2 towers with different room names, descriptions, images, etc.
// We separate the room codes here for any conditional logic.
export const WCB_TOWER_2_ROOM_TYPE_CODES = [
  'EK2',
  'SE2',
  'AP2',
  'PK2',
  'GK2',
  'AK2',
  'AQ2',
  'AS2',
  'DQ2',
  'DK2',
  'SQ2',
  'SK2',
  'GS2',
  'SGK2',
  'SGE2',
  'GE2'
];

// This is used to define which internal room type constants
// are considered premium (suites) rooms.
export const PREMIUM_ROOM_TYPE_GROUPS = [
  ULTRA_KING,
  SUITE_KING,
  GRAND_KING,
  CORNER_SUITE,
  PLATINUM_SUITE,
  EXECUTIVE_SUITE,
  GRAND_EXECUTIVE_SUITE,
  PRESIDENTIAL_SUITE,
  CHAIRMAN_SUITE,
  VILLA
];

export const PREMIUM_ROOM_TYPES = PREMIUM_ROOM_TYPE_GROUPS.reduce(
  (allRoomTypes, groupCode) => {
    return allRoomTypes.concat(ROOM_TYPE_CODES_FOR_SIZE[groupCode]);
  },
  []
).concat('EDK', 'EDKV', 'EDQ', 'EDQV');

export const PROPERTY_BASE_URL = {
  [PROPERTY_ATMORE]: 'https://windcreek.com/atmore',
  [PROPERTY_MONTGOMERY]: 'https://windcreek.com/montgomery',
  [PROPERTY_WETUMPKA]: 'https://windcreek.com/wetumpka',
  [PROPERTY_BETHLEHEM]: 'https://windcreek.com/bethlehem',
  [PROPERTY_CHICAGO]: 'https://windcreek.com/chicagosouthland'
};

export const PROPERTY_PROMOTIONS_URL = {
  [PROPERTY_ATMORE]: PROPERTY_BASE_URL[PROPERTY_ATMORE] + 'casino/promotions',
  [PROPERTY_MONTGOMERY]:
    PROPERTY_BASE_URL[PROPERTY_MONTGOMERY] + 'casino/promotions',
  [PROPERTY_WETUMPKA]: PROPERTY_BASE_URL[PROPERTY_WETUMPKA] + 'casino/gaming',
  [PROPERTY_BETHLEHEM]:
    PROPERTY_BASE_URL[PROPERTY_BETHLEHEM] + 'Gaming/Promotions.html',
  [PROPERTY_CHICAGO]: 'https://windcreek.com/chicagosouthland/promotions'
};

// Used on Guest Info in Host Booking to apply a Food/Outlet comp credit and Special Occasion
export const FOOD_COMP = 'FOOD_COMP';
export const NO_FOOD_COMP = 'NO_FOOD_COMP';
export const SPECIAL_OCCASION = 'SPECIAL_OCCASION';
export const NO_SPECIAL_OCCASION = 'NO_SPECIAL_OCCASION';
export const SEND_AMENITIES = 'SEND_AMENITIES';
export const NO_SEND_AMENITIES = 'NO_SEND_AMENITIES';

// Used in host booking to indicate that a room is fully booked.
export const NO_AVAILABILITY = 'NO_AVAILABILITY';
